var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHungerhubExclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6254 1.78395C4.16093 1.94945 3.79308 2.31599 3.62328 2.78251L0.777847 10.6003C0.465183 11.4593 0.90016 12.4063 1.7494 12.7154L7.13127 14.6742C7.98051 14.9833 8.92242 14.5375 9.23508 13.6785L12.0805 5.86069C12.2503 5.39417 12.2041 4.87694 11.9547 4.4516L10.0744 1.24509C9.67856 0.570134 8.86399 0.273652 8.12693 0.53628L4.6254 1.78395ZM7.27098 5.91766C7.90791 6.14948 8.61434 5.81512 8.84883 5.17084C9.08333 4.52656 8.7571 3.81634 8.12017 3.58452C7.48324 3.3527 6.77681 3.68706 6.54232 4.33134C6.30782 4.97562 6.63405 5.68584 7.27098 5.91766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungerhubExclusive);
export default __webpack_public_path__ + "static/media/hungerhub-exclusive.6f64c869d70a0dba731783f74f5ecbc1.svg";
export { ForwardRef as ReactComponent };